import { Slot } from '@radix-ui/react-slot';
import * as React from 'react';
import { cn } from '@ui/lib/utils';
import { buttonVariants } from '@ui/components/variants/buttonVariants';
import type { VariantProps } from 'class-variance-authority';

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      primary,
      secondary,
      dark,
      light,
      error,
      dropdownItem,
      size,
      hasError,
      asChild = false,
      type = 'button',
      ...props
    },
    ref
  ) => {
    const Comp = asChild ? Slot : 'button';
    return (
      <Comp
        className={cn(
          buttonVariants({
            primary,
            secondary,
            dark,
            light,
            size,
            error,
            hasError,
            dropdownItem,
            className,
          })
        )}
        ref={ref}
        type={type}
        {...props}
      />
    );
  }
);
Button.displayName = 'Button';
